<form [formGroup]="formLogin" id="formLogin" autocomplete="off">
  <div class="d-flex align-items-center">
    <img src="assets/logosemfundocolorida.svg" alt="logo" style="width: 300px;height: 300px;margin-top: -120px;margin-bottom: -80px;margin-left: -15px">
  </div>
  <h5 class="fw-normal mb-3 pb-3" style="letter-spacing: 1px;">O CRM que transforma contatos em contratos.</h5>

  <div data-mdb-input-init class="form-outline mb-4">
    <label class="form-label" for="form2Example17">Email</label>
    <input type="email" formControlName="email" placeholder="Digite aqui seu email" id="form2Example17" class="form-control form-control-lg" />
    <span id="nome-error-required" class="error mensagem-erro"
          *ngIf="formLogin.controls['email'].dirty &&
                      formLogin.controls['email'].errors?.required"
    >O email não pode ser vazio <br></span>
    <span id="nome-error-min-length" class="error mensagem-erro"
          *ngIf="formLogin.controls['email'].touched &&
                      formLogin.controls['email'].errors?.email"
    >Email com formato inválido.<br></span>
  </div>

  <div data-mdb-input-init class="form-outline mb-4">
    <label class="form-label" for="form2Example27">Senha</label>
    <input type="password" formControlName="senha" placeholder="Digite aqui sua senha" id="form2Example27" class="form-control form-control-lg" />
    <span id="senha-error-required" class="error mensagem-erro"
          *ngIf="formLogin.controls['senha'].dirty && formLogin.controls['senha'].errors?.required"
    >A senha não pode ser vazia <br></span>
    <span id="senha-error-min-length" class="error mensagem-erro"
          *ngIf="formLogin.controls['senha'].touched && formLogin.controls['senha'].errors?.maxlength"
    >A senha tem que ter até 20 caracteres.<br></span>
    <div class="text-right mt-1">
      <a class="small text-muted" href="#" (click)="mostrarRecuperacao=true; emailRecuperacao=formLogin.controls['email'].value; $event.preventDefault()">Esqueci a senha?</a>
    </div>

  </div>

  <div class="pt-1 text-center col-md-12">
    <button data-mdb-button-init data-mdb-ripple-init
            style="background-color: #2E5266; color: white; border-color: #2E5266;"
            class="btn btn-dark col-md-4 btn-lg btn-block" (click)="logar()" type="button">Acessar</button>
  </div>
  <div class="mb-1 mt-3 pb-lg-2 texto-cadastrese col-md-12"></div>
  <p style="color: #2E5266">Ainda não fez seu cadastro?
    <a href="https://registro.crmstack.com.br/" target="_blank" style="color: #2E5266;">Clique aqui</a>
  </p>
  <a href="#!" class="small text-muted">Termos de uso - </a>
  <a href="#!" class="small text-muted">Politica de privacidade</a>
</form>

<div class="modal-recuperacao" *ngIf="mostrarRecuperacao" (click)="mostrarRecuperacao=false">
  <div class="card p-4" (click)="$event.stopPropagation()">
    <h5>Recuperar senha</h5><p class="text-muted">Enviaremos uma senha temporária para o seu e-mail.</p>
    <label>E-mail</label><input type="email" class="form-control" [(ngModel)]="emailRecuperacao" (keyup.enter)="recuperarSenha()">
    <div class="text-right mt-3"><button class="btn btn-light mr-2" (click)="mostrarRecuperacao=false">Cancelar</button> <button class="btn btn-primary" [disabled]="enviandoRecuperacao" (click)="recuperarSenha()">{{enviandoRecuperacao ? 'Enviando...' : 'Enviar senha'}}</button></div>
  </div>
</div>
